module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cloudlinker-stat-page"
  }, [_c('div', {
    staticClass: "overview-banner"
  }, [_c('h2', [_vm._v("CloudLinker 运维审计报告")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("moment")((_vm.$route.query.time_from * 1000), 'YYYY-MM-DD HH:mm:ss')) + " ~ " + _vm._s(_vm._f("moment")((_vm.$route.query.time_end * 1000), 'YYYY-MM-DD HH:mm:ss')))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-cards"
  }, [_c('div', {
    staticClass: "overview-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("资源")]), _vm._v(" "), _c('div', {
    staticClass: "card-value assess-color"
  }, [_vm._v(_vm._s(_vm.overviewData.resources))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("工作组")]), _vm._v(" "), _c('div', {
    staticClass: "card-value work-color"
  }, [_vm._v(_vm._s(_vm.overviewData.projects))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("集群")]), _vm._v(" "), _c('div', {
    staticClass: "card-value cluster-color"
  }, [_vm._v(_vm._s(_vm.overviewData.networks))])]), _vm._v(" "), _c('div', {
    staticClass: "overview-card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-title"
  }, [_vm._v("成员")]), _vm._v(" "), _c('div', {
    staticClass: "card-value member-color"
  }, [_vm._v(_vm._s(_vm.overviewData.accounts))])])]), _vm._v(" "), _c('div', {
    staticClass: "stat-row"
  }, [_c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("活跃用户数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_account_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("被访问资源数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.resource_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("总连接次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("指令告警次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.notice_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("日均连接次数")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_days_conn_count))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("总连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.conn_time) + "小时")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("日均连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_days_conn_time) + "小时")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-item"
  }, [_c('div', {
    staticClass: "item-label"
  }, [_vm._v("平均连接时长")]), _vm._v(" "), _c('div', {
    staticClass: "item-value"
  }, [_vm._v(_vm._s(_vm.statRowData.avg_conn_time) + "小时")])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('Echarts', {
    attrs: {
      "type": "pie",
      "options": _vm.connectCountPie,
      "width": "40%",
      "height": "300px"
    }
  }), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.connectCountLine,
      "width": "60%",
      "height": "300px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('Echarts', {
    attrs: {
      "type": "pie",
      "options": _vm.connectTimePie,
      "width": "40%",
      "height": "300px"
    }
  }), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.connectTimeLine,
      "width": "60%",
      "height": "300px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "chart-group"
  }, [_c('div', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('p', [_vm._v("告警指令TOP5")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.alertTopTable,
      "height": "400"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "指令",
      "prop": "match_command"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('Echarts', {
    attrs: {
      "type": "line",
      "options": _vm.alertMultiLine,
      "width": "60%",
      "height": "400px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("成员连接次数TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.memberConnectTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "conn_count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("资源连接次数TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceConnectTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "conn_count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("成员连接时长TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.memberTimeTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时长",
      "prop": "conn_time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.conn_time / 3600).toFixed(2)) + "小时")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("资源连接时长TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceTimeTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时长",
      "prop": "conn_time"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s((scope.row.conn_time / 3600).toFixed(2)) + "小时")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-list-group"
  }, [_c('div', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('p', [_vm._v("指令告警次数/成员TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.alertMemberTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "成员",
      "prop": "account_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [_c('img', {
          staticClass: "avatar-img",
          attrs: {
            "src": _vm._f("resetURL")(scope.row.avatar)
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.account_name))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', [_vm._v("指令告警次数/资源TOP10")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.resourceAlertTop,
      "height": "400",
      "show-overflow-tooltip": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源",
      "prop": "resource_name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex items-center"
        }, [(scope.row.os === 'linux') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Linux",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/linux.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os === 'win32') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Windows",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/win32.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'postgresql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "PostgreSQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/postgresql.png",
            "width": "16",
            "height": "16",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mysql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "MySQL",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mysql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), (scope.row.os == 'mssql') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "SQL Server",
            "placement": "top"
          }
        }, [_c('img', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "src": "../../static/images/mssql.png",
            "alt": ""
          }
        })]) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "truncate"
        }, [_vm._v(_vm._s(scope.row.resource_name))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "集群",
      "prop": "network_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "IP地址",
      "prop": "resource_ip_address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "次数",
      "prop": "count"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "占比",
      "prop": "proportion"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.proportion
          }
        })]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons assess-color"
  }, [_vm._v("assessment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons work-color"
  }, [_vm._v("dvr")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons cluster-color"
  }, [_vm._v("view_list")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "material-icons member-color"
  }, [_vm._v("group")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6914310a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/overviewExportPdf.vue
// module id = 583
// module chunks = 4 5 6